export const messageTypes = {
  FormLoaded: 'gorgias-contact-form-loaded',
  AdjustIframeHeight: 'gorgias-adjust-iframe-height',
  ParentUrl: 'gorgias-parent-url',
};
